import React, { PureComponent } from 'react';
import WelltoryLink from 'components/Welltory/Link';
import cx from 'classnames';

// Utils.
import { isWebviewApp } from 'utils';

// Styles.
import styles from './styles.module.scss';

export default class Footer extends PureComponent {

  onClickWelltoryLink() {

  }

  getMenuItems() {
    const links = [];
    const isWebviewAppStatus = isWebviewApp();
    if (!isWebviewAppStatus) {
      links.push(
        <WelltoryLink
          to="https://welltory.com"
          key="footer-link-welltory1"
          className={styles.userMenuLink}
          onClick={this.onClickWelltoryLink}
        >
          Welltory Inc.
        </WelltoryLink>
      );
    }
    return links;
  }

  render() {
    const { locationPath } = this.props;
    if (/data-sources-mobile-back/.test(locationPath) === true) {
      return null;
    }
    if (/measure-details/.test(locationPath) === true) {
      return null;
    }
    const links = this.getMenuItems();
    if (links.length === 0) {
      return null;
    }
    return (
      <div className={cx(styles.footer)}>
        <div className={styles.footerMenu}>
          <div className={styles.footerMenuNavbar}>
            <div className={styles.footerMenuNav}>
              {links}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
